module.exports = __webpack_public_path__ + "assets/icEfficient.d2c4a3b0.svg";